export const RESET = 'EXSBWAREHOUSEITEM_UPDATE_RESET'
export const SET_ERROR = 'EXSBWAREHOUSEITEM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBWAREHOUSEITEM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBWAREHOUSEITEM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBWAREHOUSEITEM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBWAREHOUSEITEM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBWAREHOUSEITEM_UPDATE_UPDATE_RETRIEVED'
